import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Box, Button, Heading, Menu, ResponsiveContext, Tab, Tabs, Text, TextInput } from "grommet";
import * as React from "react";
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { usePermission, useUser } from "../account/AccountStore";
import CustomButton from "../components/CustomButton";
import LinkAnchor from "../components/LinkAnchor";
import { CoachCard } from "./CoachCard";
import { CoachViewModel } from "./CoachStore";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
// @ts-ignore
const bulkPlus = <FontAwesomeIcon size="xl" icon={["fad", "layer-plus"]}></FontAwesomeIcon>;
// @ts-ignore
const coachPlus = <FontAwesomeIcon size="xl" icon={["fad", "users-medical"]}></FontAwesomeIcon>;
const edit = <FontAwesomeIcon icon={["fad", "pencil"]}></FontAwesomeIcon>;
const idBadge = <FontAwesomeIcon icon={["fad", "id-badge"]}></FontAwesomeIcon>;
const search = <FontAwesomeIcon icon={["fad", "search"]}></FontAwesomeIcon>;

export const CoachRow = ({ coach, children }: { coach: CoachViewModel; children?: React.ReactElement }) => {
    let BoxProps = {};

    const navigate = useNavigate();

    if (!children) {
        BoxProps = {
            hoverIndicator: "background-front",
            onClick: () => {
                navigate(`/coaches/${coach.id}`);
            },
        };
    }

    return (
        <Box key={coach.id} background={"background-back"} pad="medium" direction="row" gap="small" {...BoxProps}>
            <Box justify="center">
                <img src={coach.logoUri} width="35px" alt="" />
            </Box>
            <Box justify="between" direction="row" width="100%">
                <Box justify="center">
                    <LinkAnchor path={`/coaches/${coach.id}`} label={<Text size="medium">{coach.name}</Text>}></LinkAnchor>
                </Box>
                <Box justify="center">{children}</Box>
            </Box>
        </Box>
    );
};

export const CoachTile = ({ coach }: { coach: CoachViewModel }) => {
    return (
        <Link to={`/coaches/${coach.id}`} style={{ textDecoration: "none" }}>
            <Box key={coach.id} background={"background-back"} pad="medium" gap="small" height="auto" justify="between" fill="vertical" hoverIndicator="background-front" onClick={() => {}}>
                <Box align="center" justify="center">
                    <img src={coach.logoUri} width="25px" alt="" />
                </Box>
                <Box>
                    <Box align="center" justify="center">
                        <Text size="medium">{coach.name}</Text>
                    </Box>
                </Box>
            </Box>
        </Link>
    );
};

export const CoachBlock = ({ coach, size, children }: { coach: CoachViewModel; size?: string; children?: React.ReactElement }) => {
    let { pathname } = useLocation();
    const navigate = useNavigate();

    const logoSize = size ?? "150px";

    return (
        <Link to={`/coaches/${coach.id}`} style={{ textDecoration: "none" }}>
            <Box key={coach.id} background={"background-back"} pad="medium" gap="small" height="auto" justify="between" fill="vertical" hoverIndicator="background-front" onClick={() => {}}>
                <Box align="center" justify="center">
                    <img src={coach.logoUri} width={logoSize} alt="" />
                </Box>
                <Box>
                    <Box align="center" justify="center">
                        <Text size="medium">{coach.name}</Text>
                    </Box>
                    {children && children}
                </Box>
            </Box>
        </Link>
    );
};

export const CoachGrid = ({ coaches }) => {
    const size = React.useContext(ResponsiveContext);

    const BracketGridProps = size == "small" ? { rows: ["auto"], columns: ["1/2", "1/2"] } : { rows: ["auto"], columns: ["1/4", "1/4", "1/4", "1/4"] };

    return (
        <>
            <Box direction="row" gap="medium" wrap justify="center">
                {coaches.map((coach) => (
                    <Box margin={{ bottom: "medium" }} key={coach.id}>
                        <CoachCard coach={coach}></CoachCard>
                    </Box>
                    // <CoachBlock coach={coach} key={coach.id}></CoachBlock>
                ))}
            </Box>
        </>
    );
};

const CoachesManagement = () => {
    const user = useUser();

    const [coaches, setCoaches] = React.useState([] as CoachViewModel[]);
    const [filter, setFilter] = React.useState("");
    const [filteredCoaches, setFilteredCoaches] = React.useState([] as CoachViewModel[]);
    let { pathname } = useLocation();

    React.useEffect(() => {
        // setCoaches([
        //     { id: "1", name: "Olivia Williams", games: ["minecraft", "splatoon"], logoUri: "/images/faces/1.png", price: "R150" },
        //     { id: "2", name: "Ethan Patel", games: ["fifa", "overwatch"], logoUri: "/images/faces/2.png", price: "R200" },
        //     { id: "3", name: "Sipho Maleka", games: ["valorant", "minecraft"], logoUri: "/images/faces/3.png", price: "R150" },
        //     { id: "4", name: "Benjamin Taylor", games: ["splatoon"], logoUri: "/images/faces/4.png", price: "R250" },
        //     { id: "5", name: "Isabella Martinez", games: ["overwatch", "splatoon"], logoUri: "/images/faces/5.png", price: "R200" },
        //     { id: "6", name: "Lucas Kim", games: ["minecraft", "fifa"], logoUri: "/images/faces/6.png", price: "R150" },
        //     { id: "7", name: "Ava Singh", games: ["minecraft"], logoUri: "/images/faces/7.png", price: "R200" },
        //     { id: "8", name: "Naledi Mokoena", games: ["overwatch"], logoUri: "/images/faces/8.png", price: "R250" },
        //     { id: "9", name: "Mia Brown", games: ["minecraft", "splatoon"], logoUri: "/images/faces/9.png", price: "R200" },
        //     { id: "10", name: "William Jones", games: ["minecraft", "fifa"], logoUri: "/images/faces/10.png", price: "R250" },
        // ] as CoachViewModel[]);

        setCoaches([
            { id: "4", name: "Coming Soon", games: ["minecraft", "fifa"], logoUri: "/images/faces/ph4.png", price: "-" },
            { id: "2", name: "Coming Soon", games: ["fifa", "overwatch"], logoUri: "/images/faces/ph2.png", price: "-" },
            { id: "3", name: "Coming Soon", games: ["valorant", "minecraft"], logoUri: "/images/faces/ph3.png", price: "-" },
            { id: "1", name: "Coming Soon", games: ["minecraft", "splatoon"], logoUri: "/images/faces/ph1.png", price: "-" },
        ] as CoachViewModel[]);
    }, [pathname, user]);

    React.useEffect(() => {
        if (filter) {
            setFilteredCoaches(coaches.filter((t) => t.name.toLowerCase().indexOf(filter.toLowerCase()) != -1));
        } else {
            setFilteredCoaches(coaches);
        }
    }, [coaches, filter]);

    const [index, setIndex] = React.useState(0);
    const onActive = (nextIndex: number) => setIndex(nextIndex);

    const hasWritePermission = usePermission("sport:coaches.write");

    return (
        <div style={{ filter: "grayscale()" }}>
            <Routes>
                <Route
                    path={""}
                    element={
                        <>
                            {/* <Heading size="small" textAlign="center" fill>
                                Coaches
                            </Heading> */}
                            <Box direction="row" gap="small" justify="between">
                                {hasWritePermission && (
                                    <Box direction="row" gap="small">
                                        {/* <CustomButton path={"/coaches/create"} icon={coachPlus} label="Add Coach"></CustomButton>

                                        <CustomButton path={"/coaches/createBulk"} icon={bulkPlus} label="Bulk Add"></CustomButton> */}
                                    </Box>
                                )}
                                <Box direction="row" justify="end" gap="small" align="center">
                                    <Box pad="small">
                                        <TextInput icon={search} placeholder="Search..." value={filter} onChange={(e) => setFilter(e.target.value)} disabled></TextInput>
                                    </Box>
                                    <Box pad="small" hoverIndicator="background-back" onClick={() => onActive(0)} round="5px">
                                        <FontAwesomeIcon size="lg" icon={["fad", "grid-2"]} />
                                    </Box>
                                    <Box pad="small" hoverIndicator="background-back" onClick={() => onActive(1)} round="5px">
                                        <FontAwesomeIcon size="lg" icon={["fad", "list"]} />
                                    </Box>
                                </Box>
                            </Box>
                            <Tabs activeIndex={index} onActive={onActive}>
                                <Tab>
                                    <CoachGrid coaches={filteredCoaches}></CoachGrid>
                                </Tab>
                                <Tab>
                                    <Box gap="small">
                                        {filteredCoaches.map((coach) => (
                                            <CoachRow coach={coach} key={coach.id}></CoachRow>
                                        ))}
                                    </Box>
                                </Tab>
                            </Tabs>
                            <Box pad={{ top: "small" }}>
                                {coaches.length != filteredCoaches.length && (
                                    <Text>
                                        Showing {filteredCoaches.length} of {coaches.length}{" "}
                                        <Anchor href="#" onClick={() => setFilter("")}>
                                            Show All
                                        </Anchor>
                                    </Text>
                                )}
                            </Box>
                        </>
                    }
                ></Route>
            </Routes>
        </div>
    );
};

export default CoachesManagement;
